
import React from "react";
import { Button } from "@/components/ui/button";
import { ArrowRight, Loader2 } from "lucide-react";

interface TariffActionButtonProps {
  disabled: boolean;
  loading: boolean;
  onClick: () => void;
  text?: string;
  icon?: React.ReactNode;
}

export const TariffActionButton: React.FC<TariffActionButtonProps> = ({
  disabled,
  loading,
  onClick,
  text,
  icon
}) => {
  return (
    <Button
      className="w-full py-4 sm:py-6 text-lg sm:text-xl font-semibold bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 shadow-lg transition-all duration-300 rounded-xl"
      disabled={disabled}
      onClick={onClick}
    >
      <div className="flex items-center justify-center gap-2">
        {icon ? (
          icon
        ) : loading ? (
          <Loader2 className="h-5 w-5 animate-spin" />
        ) : null}
        <span>{text || (loading ? "Обработка..." : "Выбрать тариф")}</span>
        {!loading && !icon && <ArrowRight className="ml-1 h-5 w-5" />}
      </div>
    </Button>
  );
};
